import { useRef } from 'react';
import { Paperclip, X, FileText } from 'lucide-react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import api from '../../lib/api';

export const RECEIPT_ACCEPT = 'image/jpeg,image/png,image/webp,image/gif,application/pdf';
export const receiptUrl = (id, download = false) => `${process.env.REACT_APP_BACKEND_URL}/api/files/${id}?auth=${encodeURIComponent(localStorage.getItem('token') || '')}${download ? '&download=1' : ''}`;

export const uploadCreditReceipt = async (userId, file) => {
    const fd = new FormData();
    fd.append('user_id', userId);
    fd.append('file', file);
    const { data } = await api.post('/admin/credits/receipt-upload', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
    return data.file_id;
};

export const BankTransferReceiptFields = ({ file, onFile, bankRef, onBankRef, required = true }) => {
    const ref = useRef(null);
    return (
        <div className="space-y-3 rounded-lg border border-[#1973B8]/30 bg-[#1973B8]/5 p-3" data-testid="bank-receipt-fields">
            <p className="text-[10px] uppercase tracking-[0.12em] text-[#7CB1E5] font-bold">Transferencia bancaria verificable</p>
            <div className="space-y-1.5">
                <Label className="text-slate-300 text-sm">Referencia bancaria (opcional · uso interno, no se muestra al usuario)</Label>
                <Input placeholder="Nº de operación / concepto del banco" value={bankRef} onChange={(e) => onBankRef(e.target.value)}
                    className="bg-slate-950 border-slate-800 text-white" data-testid="add-balance-bank-ref" />
            </div>
            <div className="space-y-1.5">
                <Label className="text-slate-300 text-sm">Comprobante de la transferencia {required ? <span className="text-rose-300">(obligatorio)</span> : '(opcional)'}</Label>
                <input ref={ref} type="file" accept={RECEIPT_ACCEPT} className="hidden" onChange={(e) => onFile(e.target.files?.[0] || null)} data-testid="add-balance-receipt-file" />
                {file ? (
                    <div className="flex items-center gap-2 rounded-md bg-slate-950 border border-emerald-500/40 px-3 py-2 text-xs" data-testid="add-balance-receipt-selected">
                        <FileText className="w-4 h-4 text-emerald-300 flex-shrink-0" />
                        <span className="text-white truncate flex-1">{file.name}</span>
                        <span className="text-slate-500">{Math.max(1, Math.round(file.size / 1024))} KB</span>
                        <button type="button" onClick={() => { onFile(null); if (ref.current) ref.current.value = ''; }} className="text-slate-400 hover:text-rose-300" data-testid="add-balance-receipt-clear"><X className="w-3.5 h-3.5" /></button>
                    </div>
                ) : (
                    <button type="button" onClick={() => ref.current?.click()}
                        className="w-full h-10 rounded-md border border-dashed border-slate-600 bg-slate-950/60 text-slate-300 text-xs hover:border-[#1973B8] hover:text-white flex items-center justify-center gap-2 transition-colors"
                        data-testid="add-balance-receipt-btn">
                        <Paperclip className="w-4 h-4" /> Adjuntar justificante (JPG, PNG, PDF · máx 12 MB)
                    </button>
                )}
            </div>
        </div>
    );
};
